import api from './api';
import types from './mutation-types';

export default {
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setCampaignInfoInit_({ commit }) {
		commit(types.CAMPAIGN_INFO_INIT);
	},
	setCampaignInfo_({ commit }, { key, value }) {
		commit(types.CAMPAIGN_INFO, { key, value });
	},
	getCampaignList_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getCampaignList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'campaignList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getCampaignInfo_({ commit, state }, param) {
		return api
			.getCampaignInfo(param)
			.then(data => {
				//console.log('data', data);
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'campaignInfo',
						value: data?.body.campaignDetail || {}
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async savecampaignInfo_(store, { saveParams }) {
		return api
			.savecampaignInfo({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async deletecampaignInfo_(store, { cmpnNo, deleteParams }) {
		try {
			const { header } = await api.deleteCampaignInfo({ cmpnNo, deleteParams });
			return header;
		} catch (error) {
			return error.header || error;
		}
	}
};
